export var ClassificationScheduleFrequency;
(function (ClassificationScheduleFrequency) {
    ClassificationScheduleFrequency["CLASSIFICATION_SCHEDULE_DAILY"] = "DAILY";
    ClassificationScheduleFrequency["CLASSIFICATION_SCHEDULE_WEEKLY"] = "WEEKLY";
    ClassificationScheduleFrequency["CLASSIFICATION_SCHEDULE_MONTHLY"] = "MONTHLY";
    ClassificationScheduleFrequency["CLASSIFICATION_SCHEDULE_ANNUALLY"] = "ANNUALLY";
    ClassificationScheduleFrequency["CLASSIFICATION_SCHEDULE_UNSPECIFIED"] = "UNSPECIFIED";
})(ClassificationScheduleFrequency || (ClassificationScheduleFrequency = {}));
